import { Injectable, Injector } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpResponse, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { tap, catchError } from 'rxjs/operators';
import { UtilsService } from '../utils/utils.service';

/**
 * HTTP Interceptor that tracks all HTTP request success/failure rates
 * to provide smart online/offline status detection.
 *
 * This interceptor monitors ALL HTTP requests (not just API calls) to detect
 * network connectivity issues and prevent false offline states caused by browser bugs.
 */
@Injectable()
export class NetworkStatusInterceptor implements HttpInterceptor {
    constructor(private readonly injector: Injector) {}

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(req).pipe(
            tap((event: HttpEvent<any>) => {
                if (event instanceof HttpResponse) {
                    // Track successful HTTP request
                    const utilsService = this.injector.get(UtilsService);
                    utilsService.recordHttpRequestSuccess();
                }
            }),
            catchError((error: HttpErrorResponse) => {
                // Track failed HTTP request
                const utilsService = this.injector.get(UtilsService);

                // Check if this is a network error (status 0 typically indicates network failure)
                const isNetworkError = error.status === 0 || !navigator.onLine;
                utilsService.recordHttpRequestFailure(isNetworkError);

                return throwError(() => error);
            })
        );
    }
}
